import { Component, Prop, Vue } from 'vue-property-decorator';
import { hasSeated } from '@/helpers/TicketGroupHelpers';
import TicketGroupSeatBadge from '@/components/events/TicketGroupSeatBadge.vue';
import TicketTypeStepper from '@/components/events/TicketTypeStepper.vue';
@Component({
    name: 'SelectGroupQuantities',
    components: {
        TicketTypeStepper,
        TicketGroupSeatBadge,
    },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    ticketGroup;
    @Prop({ required: true })
    quantities;
    @Prop({ required: true })
    remainingCapacity;
    @Prop({ default: false })
    giftOfMembership;
    @Prop({ default: false })
    showAdvertisedFees;
    @Prop({ default: false })
    exactlyOneTicket;
    get showName() {
        const tg = this.ticketGroup;
        if (this.isSeated) {
            return true;
        }
        else {
            // Only show the TG name if the description is empty, or it matches the name.
            // TODO Why is there special behaviour for a name that matches the description?
            // There is some similar behavior in <TicketTypeStepper> for subtitles.
            // @see https://tixtrackteam.slack.com/archives/CN2J3BTK7/p1721098347028419
            return tg.description.length > 0 && tg.description !== tg.name;
        }
    }
    get isSeated() {
        return hasSeated([this.ticketGroup]);
    }
    get className() {
        if (!this.isSeated) {
            return null;
        }
        let className = '';
        // TODO Remove this once `tg_seat_accessibility` flag is removed.
        if (this.flags.tg_seat_accessibility) {
            className = 'tg-seat-accessible';
        }
        return this.ticketGroup.isAccessible
            ? `${className} ticket-group-accessible-color`
            : `${className} ticket-group-${this.ticketGroup.color}-color`;
    }
    get groupMinQuantity() {
        const group = this.ticketGroup;
        // Only apply the minimum guard when the group has a single ticket type
        if (group.types.length === 1 && group.min_tickets_per_order) {
            return Math.max(Number(group.min_tickets_per_order), 1);
        }
        else {
            return 1;
        }
    }
    get isSoldOut() {
        // Only SessionTGs and LinkedSessionTGs have the `sold_out` property. Other TG types do not.
        if ('sold_out' in this.ticketGroup)
            return this.ticketGroup.sold_out;
        else
            return false;
    }
}
